/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1InsideweightsQueryResponse } from '../../types/GetV1Insideweights.ts'

export const getV1InsideweightsQueryKey = () => [{ url: '/v1/InsideWeights' }] as const

export type GetV1InsideweightsQueryKey = ReturnType<typeof getV1InsideweightsQueryKey>

/**
 * {@link /v1/InsideWeights}
 */
export async function getV1Insideweights(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1InsideweightsQueryResponse, ResponseErrorConfig<Error>, unknown>(
        { method: 'GET', url: `/v1/InsideWeights`, ...requestConfig },
    )
    return res
}

export function getV1InsideweightsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1InsideweightsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1InsideweightsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1InsideweightsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Insideweights(config)
        },
    })
}

/**
 * {@link /v1/InsideWeights}
 */
export function useGetV1Insideweights<
    TData = ResponseConfig<GetV1InsideweightsQueryResponse>,
    TQueryData = ResponseConfig<GetV1InsideweightsQueryResponse>,
    TQueryKey extends QueryKey = GetV1InsideweightsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1InsideweightsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1InsideweightsQueryKey()

    const query = useQuery(
        {
            ...getV1InsideweightsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
